import csrApi from "../api/serve";

export default {
    state: {
        kv: {},
        content: {},
        closeKv: true,
    },
    mutations: {
        saveKv(state, data) {
            state.kv = data.banner;
        },
        saveContent(state, data) {
            state.content = data[0];
        },
    },
    actions: {
        async fetchKv({ commit }, parameter) {
            try {
                const response = await csrApi.get(
                    `/banner?uri=${parameter.content}&country_code=${parameter.lang}`
                );
                commit("saveKv", response.data);
            } catch (err) {
                console.log("kv", err.response.data);
            }
        },
        async fetchContent({ commit }, parameter) {
            try {
                const response = await csrApi.get(
                    `/webpage?uri=${parameter.content}&country_code=${parameter.lang}`
                );
                commit("saveContent", response.data.webpage);
            } catch (err) {
                console.log("content", err);
            }
        },
    },
    getters: {
        getKvData(state) {
            return state.kv;
        },
        getContentData(state) {
            return state.content;
        },
    },
    modules: {},
};
